module.exports = __webpack_public_path__ + "img/betamars.21a0f153.svg";